import { render, staticRenderFns } from "./CreatePubgMobileTournament.vue?vue&type=template&id=8bd25412&lang=pug"
import script from "./CreatePubgMobileTournament.vue?vue&type=script&lang=js"
export * from "./CreatePubgMobileTournament.vue?vue&type=script&lang=js"
import style0 from "./CreatePubgMobileTournament.vue?vue&type=style&index=0&id=8bd25412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports